import { render, staticRenderFns } from "./OrganizationInformation.vue?vue&type=template&id=1a4590b0"
import script from "./organization-information.ts?vue&type=script&lang=ts&external"
export * from "./organization-information.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports